// extracted by mini-css-extract-plugin
module.exports = {"printOnlyFooter":"footerPrintOnly_printOnlyFooter__2-Qr6","printOnlyFooterText":"footerPrintOnly_printOnlyFooterText__3yHpB"};